module.exports = __webpack_public_path__ + "img/flora-logo-icon.1f4ef17c.png";